import { Module } from 'vuex';
import { DetectionRulesRecordState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: DetectionRulesRecordState = {
    detectionRulesRecords: undefined,
    detectionRulesRecordCount: 0,
    detectionRulesRecordDetails: undefined,
    logFileDetails: undefined,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    logFile: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

export const detectionRulesRecord: Module<DetectionRulesRecordState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
